import { CardHeader, Card, CardContent, Collapse, IconButton, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import JsBarcode from "jsbarcode";
import { useEffect, useRef } from "react";

const classes: any = {
	cardHeader: {
		backgroundColor: "primary.light",
		color: "white",
		alignItems: "center",
		textAlign: "center",
		paddingLeft: '56px',
		cursor: "pointer",
	},
	cardContent: {
		textAlign: "center",
		backgroundColor: "white",
		paddingBottom: '14px !important'
	},
	expandButton: {
		color: "white",
	}
};

interface Props {
	barcodeOpened: boolean;
	memberID: string;
	user: { fullName: string };
	openBarcode: (opened: boolean) => void;
}

export default function Barcode(props: Props) {
	const expanded = props.barcodeOpened;
	const barcodeRef = useRef<SVGSVGElement>(null);

	useEffect(() => {
		if (expanded && props.memberID && barcodeRef.current) {
			try {
				// Clear any existing barcode
				while (barcodeRef.current.firstChild) {
					barcodeRef.current.removeChild(barcodeRef.current.firstChild);
				}
				
				// Generate new barcode
				JsBarcode(barcodeRef.current, props.memberID, {
					format: "CODE128",
					lineColor: "#000",
					width: 2,
					height: 100,
					displayValue: true,
					fontSize: 20,
					margin: 10,
					background: "#ffffff"
				});
			} catch (error) {
				console.error("Failed to generate barcode:", error);
			}
		}
	}, [props.memberID, expanded]);

	return (
		<Card raised={true} sx={{ pb: 0 }}>
			<CardHeader
				action={
					<IconButton
						aria-expanded={expanded}
						aria-label="show barcode"
						sx={classes.expandButton}
					>
						{expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
					</IconButton>
				}
				sx={classes.cardHeader}
				title="Check-In Barcode"
				onClick={() => props.openBarcode(!expanded)}
			/>
			<Collapse in={expanded} timeout="auto" unmountOnExit>
				<CardContent sx={classes.cardContent}>
					{props.memberID ? (
						<svg ref={barcodeRef}></svg>
					) : (
						<p>No member ID available</p>
					)}
					<Typography variant="body1" sx={{fontSize: 18, fontWeight: 'bold'}}>
						{props.user.fullName}
					</Typography>
				</CardContent>
			</Collapse>
		</Card>
	);
}
